import { registerCondition } from '../conditionRegisterer';
export var CONDITION_NAME = 'true';
export function condition() {
  return true;
}
registerCondition(CONDITION_NAME, condition, {
  name: 'True'
});


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/es/plugins/filters/condition/true.js
// module id = va9h
// module chunks = 0